













































































import { Component, Mixins } from 'vue-property-decorator';
import { Actions, Mutations } from '@/ts/store/Constants';
import DateMethods from '@/mixins/DateMethods.vue';
import TicketHelper from '@/mixins/TicketHelper.vue';
import InlineImages from '@/components/Gallery/InlineImages.vue';

@Component({
    components: {
        InlineImages,
    },
})
export default class PreviewTicket extends Mixins(DateMethods, TicketHelper) {
    public allowUnread: boolean = true;

    constructor() {
        super();
    }

    get userCurrentTicket() {
        return this.$store.getters['UserTickets/getUserCurrentTicket'];
    }

    get ticketMedias() {
        return this.$store.getters['UserTickets/getActiveTicketImages'];
    }

    get hasMedias() {
        return typeof this.ticketMedias !== 'undefined' && this.ticketMedias.length;
    }

    public returnTicketState(state: string) {
        if (state === 'new') {
            return 'Pending';
        } else if (state === 'open') {
            return 'In-progress';
        } else if (state === 'closed') {
            return 'Cancelled';
        } else {
            return 'Completed';
        }
    }

    public userCancelTicket(ticketId: number) {
       this.$store.dispatch(Actions.USER_CANCEL_TICKET, ticketId);
    }

    public userPreviewTicketConversation(ticketId: number) {
        this.$store.commit(Mutations.SET_PREVIEW_TICKET_CONVERSATION_VISIBILITY, true);
        this.allowUnread = false;
    }

    public cancel() {
        this.$store.commit(Mutations.SET_PREVIEW_TICKET_VISIBILITY, false);
    }

    public created() {
        this.$store.dispatch(Actions.FETCH_TICKET_IMAGES, this.userCurrentTicket.id);
    }

    public mounted() {
        if (typeof this.$route.params.ticketId !== 'undefined') {
            this.userPreviewTicketConversation(Number(this.$route.params.ticketId));
        }
    }

    public beforeDestroy() {
        if (typeof this.$route.params.ticketId !== 'undefined') {
            delete this.$route.params.ticketId;
        }

        this.$store.commit(Mutations.SET_ACTIVE_TICKET_IMAGES, []);
    }
}
